// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xu_a bhy_a bhy_x","StrollerDetailRating__muted":"xu_b bhy_fo"};